import { Base2Presenter } from "core/presenter";

export default class ImportStockCountPresenter extends Base2Presenter {
  initialState() {
    return {
      activeStep: 0
    };
  }

  downloadCsv() {
    this.props.downloadCsv();
    this.handleNext();
  }

  handleNext() {
    this.enqueue(vm => ({ activeStep: vm.activeStep + 1 }));
  }

  handleBack() {
    this.enqueue(vm => ({ activeStep: vm.activeStep - 1 }));
  }

  handleReset() {
    this.enqueue({ activeStep: 0 });
  }

  handleModal() {
    this.props.onImportStockCountClose();
    setTimeout(() => this.handleReset(), 200);
  }

  handleImport() {
    this.props.onImportStockCountConfirmation();
    this.handleModal();
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/product/inventory/adjust/import-stock-count/presenter.js